import Vue from "vue";
import router from "../router";
import ELYXConstants from "./ELYXConstants";
import ItemStore from "./Items/ItemStore";
import SpaceStore from "./Spaces/SpaceStore";
import SidebarElementStore from "./SidebarElements/SidebarElementStore";
import SubspaceStore from "./Subspaces/SubspaceStore";
import PropertyStore from "./Properties/PropertyStore";
import SettingsStore from "./Settings/SettingsStore";
import ProfileStore from "./Profiles/ProfileStore";
import SubscriptionStore from "./Subscriptions/SubscriptionStore";
import CalendarStore from "./Calendar/CalendarStore";
import AdminDashboardStore from "./AdminDashboard/AdminDashboardStore";
import BadgeStore from "./Badges/BadgeStore";
import SettingsMethods from "./Settings/SettingsMethods";
import InternalAPI from "./Internal/InternalAPI";

/** Initialize ELYX Central Store for values to be utilized outside any particular context */
const getDefaultState = () => {
  return {
    activeModal: null, // null or object
    activeDropdown: {
      id: null,
      name: null,
      left: null,
      top: null,
    },
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },
  setModal(modal) {
    state.activeModal = modal;
  },
  closeModal() {
    if (state.activeModal === null) {
      return;
    }

    const modalName = state.activeModal.name;
    const modals = ELYXConstants.modals;
    const route = router.currentRoute;

    if (modalName === modals.SubscriptionModalSuccess.name || modalName === modals.SubscriptionModalFail.name) {
      if (route.query.subscription !== undefined) {
        router.replace({
          query: { ...route.query, subscription: undefined },
        });
      }
    } else if (modalName === modals.Settings.name || modalName === modals.SubscriptionModal.name) {
      if (Object.keys(route.query).length > 0) {
        router.push({ query: {} });
      }
    }
    state.activeModal = null;
  },
  checkIfAnyModalsNeedOpening() {
    const route = router.currentRoute;

    if (route.query.settings || route.query.code) {
      SettingsMethods.openSettingsModal();
    }
    if (route.query.subscription) {
      if (route.query.subscription === "success") {
        state.activeModal = ELYXConstants.modals.SubscriptionModalSuccess;
        InternalAPI.logEvent("CompletePayment", "Post Subscription Success");
      } else if (route.query.subscription == "fail") {
        state.activeModal = ELYXConstants.modals.SubscriptionModalFail;
      }
    }
  },

  /**
   * @param {Object} target An event's target
   * @param {String} name Same as class name of dropdown button
   */
  setDropdown(target, name) {
    /** Get the original dropdown button being clicked */
    const element = target.classList.contains(name) ? target : target.closest("." + name);

    /** Extract unique ID of dropdown button */
    const id = element.id;

    /** If same dropdown is already active, ensure it's not opened again */
    if (state.activeDropdown.name === name && state.activeDropdown.id === id) {
      methods.disableActiveDropdown();
      return;
    }

    /** Set new dropdown */
    const rect = element.getBoundingClientRect();
    const left = `${rect.left}px`;
    const top = `${rect.bottom}px`;
    state.activeDropdown = { id, name, left, top };
  },
  disableActiveDropdown() {
    state.activeDropdown = { id: null, name: null, left: null, top: null };
  },
};

const ELYXCentralStore = { state, methods };

export {
  ELYXCentralStore,
  ItemStore,
  SpaceStore,
  SidebarElementStore,
  SubspaceStore,
  PropertyStore,
  SettingsStore,
  ProfileStore,
  SubscriptionStore,
  CalendarStore,
  AdminDashboardStore,
  BadgeStore,
};
